/* eslint-disable */

export const optoutTranslations = {
  en: {
    deactivateBtn: 'Control your ad settings'
  },
  fr: {
    deactivateBtn: 'Définir vos préférences publicitaires'
  },
  de: {
    deactivateBtn: 'Kontrollieren Sie Ihre Werbungs-Einstellungen'
  },
  it: {
    deactivateBtn: 'Controlla le impostazioni della tua inserzione'
  },
  es: {
    deactivateBtn: 'Controle su configuración de publicidad'
  },
  ja: {
    deactivateBtn: '広告設定を管理'
  },
  ru: {
    deactivateBtn: 'Управление настройками рекламы'
  },
  nl: {
    deactivateBtn: 'Beheer uw advertentie-instellingen'
  },
  sv: {
    deactivateBtn: 'Justera inställningarna av din annons'
  },
  da: {
    deactivateBtn: 'Administrer dine annonceindstillinger'
  },
  pl: {
    deactivateBtn: 'Przejmij kontrolę nad reklamami'
  },
  cs: {
    deactivateBtn: 'Mějte nastavení reklam pod kontrolou'
  },
  nb: {
    deactivateBtn: 'Kontroller annonseinnstillingene dine'
  },
  fi: {
    deactivateBtn: 'Määritä mainosasetuksesi'
  },
  ar: {
    deactivateBtn: 'تحكّم في إعدادات إعلاناتك'
  },
  pt: {
    deactivateBtn: 'Controle as suas definições de anúncios'
  }
};
